
<ul>
  <li v-for="(item, index) in itemsWithText" :key="index" :class="item.text && `mb-${customMargin} last:mb-0`">
    <div class="flex items-center gap-8">
      <component :is="item.icon" :color="iconColor" :width="iconSize" :height="iconSize" aria-hidden="true" />
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p :class="[textClasses, item.clickHandler && 'cursor-pointer']" @click="handleClick(item)" v-html="item.text" />
    </div>
  </li>
</ul>
